import React from 'react';

const CantQuoteAutomatically = () => (
  <div className="row cannot-quote-automatically">
    <div className="col-md-12">
      <div className="alert alert-info" role="alert">
        <h3>
          <span className="glyphicon glyphicon-info-sign" />Sorry, we can
          not get an automatic quote for the combination of parameters
          that you have selected.
        </h3>
        <p>
          Choose other values for the parameters and press Requote button.
          Even want to get a quote you can do it from our <a href="/custom_quote_request">Custom Quotes</a> page,
          we will respond within 24 hours.
        </p>
      </div>
    </div>
  </div>
);

export default CantQuoteAutomatically;
